// extracted by mini-css-extract-plugin
export default {"wrapper":"MatchBetList_wrapper__7RjwA","title":"MatchBetList_title__AiymG","betWrapper":"MatchBetList_betWrapper__uTth8","iconsWrapper":"MatchBetList_iconsWrapper__1Ro7y"};